export const ADD_TEAM = 'parcel/addTeam/ADD_TEAM';
export const ADD_TEAM_SUCCESS = 'parcel/addTeam/ADD_TEAM_SUCCESS';
export const ADD_TEAM_ERROR = 'parcel/addTeam/ADD_TEAM_ERROR';
